module.exports = __webpack_public_path__ + "img/AsiaToday.3be09e4.png";